import { Inject } from '@odinjs/odin';
import { AvatarAPI, BarcodeAPI, BarcodeData, PanelAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { ButtonTheme, Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService, MessageService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { Endpoint } from '../../../../constants/endpoints';
import { ApplicationRoute } from '../../../../constants/routes';
import { FoundationUtils } from '../../../../utils/foundation-utils';
import { SEC_9131Parameters } from '../../../../utils/parameters';
import BaseController from '../../../BaseController';
import {SendContainerAliases as Alias, FragmentNames} from '../../../../codegen';
import BarcodeService from '../../../../services/barcode-service';
export const PendingExamsModalId = 'pending-exams-modal';

interface Container {
  gearCode: string;
  gearName: string;
  gearTypeName: string;
}

@Controller({ component: Alias.SEND_CONTAINER_LAYOUT, fragment: FragmentNames.SEND_CONTAINER })
class SendContainerController extends BaseController {

  @Inject(Alias.SEND_CONTAINE_PANEL)
  private sendButtonPanel!: PanelAPI;

  @Inject(Alias.BARCODE_EXAM_CONTAINER)
  private sendBarcodeApi!: BarcodeAPI;

  @Inject(Alias.AVATAR_SEND_CONTAINER)
  private avatarAPI!: AvatarAPI;

  @OnMount(Alias.AVATAR_SEND_CONTAINER)
  handleMountAvatar(): void {
    const desktopNotSupported = '../../../../../resources/assets/desktop_not_supported.svg';
    this.avatarAPI.setImage(desktopNotSupported);
  }

  @OnMount({ target: Alias.SEND_CONTAINER_LAYOUT })
  onMount(): void {
    const body = {
      expressionCode: 1064789,
      functionCode: 9131
    }
    HttpService.post(Endpoint.RECORD_AUDIT_LOG, {}, { body })

    const tasyFunctionName = 'SEND_EXAM_SAMPLE#9131';
    const consistOnSend = FoundationUtils.findModuleParam(tasyFunctionName, SEC_9131Parameters.CONSIST_GEAR_ON_SEND);

    if ('S' === consistOnSend) {
      this.sendButtonPanel.setVisible(false);
      this.sendBarcodeApi.setButtonTheme(ButtonTheme.PRIMARY);
    }
  }

  @OnClick({ target: Alias.BUTTON_SEND_CONTAINER })
  onClick(): void {
    const prescription = 'undefined';
    applicationContext.redirect(ApplicationRoute.SEND_PRESCRIPTION, { prescription });
  }

  @OnMount(Alias.BARCODE_EXAM_CONTAINER)
  handleMountBarcode(event: MountEvent): void {
    const barcodeApi = event.target as BarcodeAPI
    barcodeApi.setDefaultReadType(BarcodeService.getDefaultMethodOfReadingBarcode())
  }

  @OnReadSuccess({ target: Alias.BARCODE_EXAM_CONTAINER })
  readSuccess(event: ReadEvent<BarcodeData>):void {
    const queryParams = {
      container: event.item.value.trim()
    }

    HttpService.get(Endpoint.GET_EXAM_CONTAINER, queryParams).then(resp => {
      const container = resp.body as Container;
      if (container) {
        this.showGetContainerToast('text.exam-container-successfully-found', ToastLevel.SUCCESS);
        const prescription = container.gearCode + ' - '  + container.gearName;
        applicationContext.redirect(ApplicationRoute.SEND_PRESCRIPTION, { prescription });
      } else {
        this.showGetContainerToast('text.exam-container-not-found', ToastLevel.ERROR)
      }
    }).catch(() => this.showGetContainerToast('text.exam-container-not-found', ToastLevel.ERROR)
    );
  }

  showGetContainerToast(message: string, level: ToastLevel): void {
    const toastId = message;
    ToastService.close(toastId);
    ToastService.open({
      dismissible: true,
      id: toastId,
      level: level,
      message: MessageService.translate(message),
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }

}

export default SendContainerController;
